import { ReactElement } from 'react';
import Image from 'next/image';
import styles from './SauceBenefits.module.scss';
import { BASE_PATH } from '../services/public-config';

const testimonials = [
  'The services provided by Sauce Labs have aided us in scaling out our UI automation testing ' +
    'effort without the hassle of trying to implement and maintain a Selenium Grid on our own.',
  'One thing I enjoy a lot is how fast support team is with responding and resolving issues.',
  'Sauce Labs helped our organization to meet customer experience requirements by finding issues ' +
    'at the very early stages of the product development phase which helped us to enhance the UI very well',
];

export default function SauceBenefits(): ReactElement | null {
  return (
    <div className={styles.sauceBenefits}>
      <h3>
        <span className={styles['new-tag']}>New</span>
        <span>
          <strong>free</strong> Plan (Doesn&apos;t expire)
        </span>
      </h3>
      <ul>
        <li>
          <Image alt="Credit card" src={`${BASE_PATH}/credit-card.svg`} width="26" height="20" />
          <span>Receive 2,000 free credits every week</span>
        </li>
        <li>
          <Image alt="Devices" src={`${BASE_PATH}/devices.svg`} width="26" height="20" />
          <span>Test on Real and Virtual Devices</span>
        </li>
        <li>
          <Image alt="Speedometer" src={`${BASE_PATH}/speedometer.svg`} width="26" height="20" />
          <span>10 concurrency for speed and parallelization</span>
        </li>
        <li>
          <Image alt="Feature set" src={`${BASE_PATH}/multiple-offerings.svg`} width="26" height="20" />
          <span>Access API, Mobile Beta, Live and Automated Testing</span>
        </li>
        <li>
          <Image alt="Invite" src={`${BASE_PATH}/invite.svg`} width="26" height="20" />
          <span>Invite unlimited users</span>
        </li>
      </ul>
      <hr />
      <div className={styles.testimonials}>
        {['goldstar_1', 'goldstar_2', 'goldstar_3', 'goldstar_4', 'goldstar_5'].map((index) => (
          <div key={index} className={styles.goldStar} style={{ backgroundImage: `url("${BASE_PATH}/gold-star.svg")` }} />
        ))}
        <div className={styles.verifiedUser}>
          <img src={`${BASE_PATH}/checkmark-verified.svg`} alt="Green checkmark" />
          Verified User
        </div>
        <div className={styles.testimonialSlider}>
          {testimonials.map((testimonial) => (
            <div key={testimonial} className={styles.testimonial}>
              &quot;{testimonial}&quot;
            </div>
          ))}
        </div>
      </div>
      <hr />
      <h4>Start testing like</h4>
      <div className={styles.logos}>
        <div>
          <img src={`${BASE_PATH}/stripe-logo.svg`} alt="Stripe logo" />
        </div>
        <div>
          <img src={`${BASE_PATH}/walmart-logo.svg`} alt="Walmart logo" />
        </div>
        <div>
          <img src={`${BASE_PATH}/visa-logo.svg`} alt="Visa logo" />
        </div>
      </div>
    </div>
  );
}
